import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { normalizeUnit } from "../../../../utils/normalizeUnit";
import { formatWhole, formatMagnitude, formatMagnitudeAdaptive } from "../../../../utils/numberFormat";
import { apiRetry } from "../../../../utils";
import {
  Table,
  Dropdown,
  Confirm,
  Icon,
  Label,
  Button,
  Popup,
} from "semantic-ui-react";
import { Line } from "@ant-design/charts";
import { Pie, Column, DualAxes } from "@ant-design/plots";
import {
  Form,
  Permission,
  Productionform,
  Role,
  Socialform,
  Wasteform,
} from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./WasteKPIsDashBoard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { CollapsibleSection, LoadingSpinner } from "../../../Shared";
import { Link } from "react-router-dom";
import {
  disposalMethodCode,
  disposalMethods,
} from "../../../../utils/dataAndFormulas/wasteForms";
//import { Renderer as SVGRenderer } from '@antv/g-svg';
import WasteSummary from "./Wastesummary";
import TableGraf from "./TableGraf";
import KPIExportIconButton from "../KPIExportIconButton";
import {
  wasteKPIsCodes,
  wasteFormulasIndicators,
  determineWasteUnits,
  wasteCodes,
  convertWithDensityWaste,
  densidades,
  convertUnitsFinal,
} from "../../../../utils/dataAndFormulas/wasteForms";

import {
  convertUnits,
  formatValue,
} from "../../../../utils/dataAndFormulas/convert";
import convert from "convert-units";
import { isAdmin, isMaster } from "../../../../utils/checkPermission";
import { BAR_PALETTE } from "../../../../utils/chartConfig";
import {
  buildWasteComparisonData,
  buildWasteComparisonDataPeligrosos,
} from "./wasteChartData";
import { drawWasteCustomCharts } from "./pdfWasteCharts";

const permissionController = new Permission();
const wasteController = new Wasteform();
const formController = new Form();
const productionController = new Productionform();
const socialController = new Socialform();

export function WasteKPIsDashBoard(props) {
  const { site, sharedProductionForms, siteName = "" } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");

  const [data, setData] = useState([]);
  const [dateDetailPerConcept, setDataDetailPerConcept] = useState({});
  const [dataDisposalRaw, setDataDisposalRaw] = useState({});
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);
  const [valueBaseline, setValueBaseline] = useState({});
  // Evita que el cálculo principal corra con un valueBaseline todavía vacío
  // (que dispara falsos "línea base no configurada" y KPIs en 0 hasta refrescar
  // la página, por una carrera entre el fetch de datos y el fetch de baseline)
  const [baselineLoaded, setBaselineLoaded] = useState(false);
  const [missingBaselineYears, setMissingBaselineYears] = useState([]);
  const [indicatorsLineBase, setIndicatorsLineBase] = useState([]);

  const [workersTotals, setWorkersTotals] = useState([]);
  const [workersTotalsByPeriod, setWorkersTotalsByPeriod] = useState({}); // trabajadores por periodo (mes)
  const [configFormData, setConfigFormData] = useState(null); // ✅ Nuevo estado para Form config
  const [unitsRecorded, setUnitsRecorded] = useState({}); // ✅ Nuevo estado para unidades guardadas
  const [reloadUnits, setReloadUnits] = useState(0); // ✅ Trigger para recargar unidades

  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;

  const [lastYears, setLastYears] = useState({}); // resultados calculados
  const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados
  const [totalesProductionsByFilters, setTotalesProductionsByFilters] =
    useState({}); // resultados de producción por mes

  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

  //declaración estado de filtros
  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsActive(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsActive([]);
      } finally {
        stopLoading();
      }
    })();
  }, []);

  // ✅ Nuevo useEffect para cargar la configuración del Form (unidades guardadas)
  useEffect(() => {
    (async () => {
      try {
        if (site && site !== "" && site !== "undefined") {
          console.log(
            "🔄 WasteKPIsDashBoard: Cargando Form config para site:",
            site,
          );

          const response = await formController.getFormsBySite(
            accessToken,
            site,
            "waste",
          );

          //console.log(`📋 Forms encontrados: ${response.length}`);

          if (response.length > 0) {
            //console.log("📄 Form data:", response[0]);
            setConfigFormData(response[0]);

            // Extraer las unidades guardadas en el Form
            const savedUnits = {};
            response[0].fields?.forEach((field) => {
              if (field.unit && field.name) {
                savedUnits[field.name] = field.unit;
              }
            });

            //console.log("💾 Unidades extraídas del Form:", savedUnits);
            console.log(
              `📊 Total de unidades guardadas: ${
                Object.keys(savedUnits).length
              }`,
            );

            setUnitsRecorded(savedUnits);
          } else {
            //console.log("⚠️ No se encontró Form para el sitio");
            setConfigFormData(null);
            setUnitsRecorded({});
          }
        }
      } catch (error) {
        console.error("❌ Error al cargar configuración de Form:", error);
        setConfigFormData(null);
        setUnitsRecorded({});
      }
    })();
  }, [site, accessToken, reloadUnits]); // ✅ Se recarga cuando cambia reloadUnits

  // ✅ Detectar cuando la ventana recupera el foco (usuario vuelve de otra pestaña)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && site) {
        // La ventana está visible nuevamente, recargar unidades
        setReloadUnits((prev) => prev + 1);
      }
    };

    const handleFocus = () => {
      if (site) {
        // La ventana recuperó el foco, recargar unidades
        setReloadUnits((prev) => prev + 1);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [site]);

  useEffect(() => {
    (async () => {
      if (!site) return;

      startLoading();
      try {
        setData([]);

        const currentYear = new Date().getFullYear();
        const yearsUltimos5 = [
          currentYear,
          currentYear - 1,
          currentYear - 2,
          currentYear - 3,
          currentYear - 4,
        ].map(String);

        // 🚀 Paralelizar la primera consulta de baseline
        const prueba = await apiRetry(() => wasteController.getWasteFormsByLineBaseYears(accessToken, site));

        setIndicatorsLineBase(prueba.wasteForms.indicators);
        const añosCombinados = [
          ...new Set([...prueba.wasteForms.years, ...yearsUltimos5]),
        ];

        // 🚀 Paralelizar las consultas de datos y trabajadores
        const [response, totalWorkersByYear, totalWorkersByYearAndPeriod] =
          await Promise.all([
            apiRetry(() => wasteController.getWasteFormsByLastYears(accessToken, site, añosCombinados)),
            socialController.getTotalWorkersByYears(
              accessToken,
              site,
              añosCombinados,
            ),
            socialController.getTotalWorkersByYearsAndPeriod(
              accessToken,
              site,
              añosCombinados.map(String),
            ),
          ]);

        setData(response.wasteForms);
        setWorkersTotals(totalWorkersByYear.totalWorkers);
        setWorkersTotalsByPeriod(
          totalWorkersByYearAndPeriod.totalWorkersByPeriod || {},
        );
      } catch (error) {
        console.error("Error loading waste data:", error);
        setData([]);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      startLoading();
      setbaseline("");
      // Al cambiar de sitio, bloquear el cálculo principal hasta que el
      // baseline de ESTE sitio termine de cargar (ver baselineLoaded más abajo)
      setBaselineLoaded(false);
      try {
        if (site) {
          const response = await apiRetry(() =>
            formController.getLastBaselineByFormBySite(
              accessToken,
              site,
              "production",
            )
          );

          if (response.code === 200) {
            setbaseline(response.baseline);

            //Para saber el total de los años de baseline sin necesidad de andar consultando varias veces
            const resultado = await Promise.all(
              Object.entries(response.baseline)
                .filter(([anio, valor]) => valor !== null) // Filtra por los valores no nulos
                .map(async ([anio, valor]) => {
                  let a = await getValueBaseLine(anio, valor); // Llamada a la función asincrónica
                  return { [anio]: a }; // Devuelve el año y el valor como un objeto
                }),
            );

            // Combina todos los objetos en un único objeto final
            const resultadoFinal = resultado.reduce((acc, obj) => {
              return { ...acc, ...obj }; // Combina los objetos
            }, {});

            setValueBaseline(resultadoFinal);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoading();
        // Recién ahora es seguro que el cálculo principal corra con el
        // valueBaseline real de este sitio (exista o no línea base configurada)
        setBaselineLoaded(true);
      }
    })();
  }, [site]);

  // Función que obtiene los campos fuente de un KPI basándose en wasteFormulasIndicators
  const getKPISourceFields = useCallback((kpiName) => {
    const kpiSourceMap = {
      // Residuos no peligrosos
      paper_and_cardboard_kpis: ["paper_and_cardboard"],
      plastic_kpis: ["plastic"],
      fabric_or_scraps_kpis: ["fabric_scraps"],
      metal_kpis: ["metal_clean"],
      wood_kpis: ["wood"],
      leftover_food_kpis: ["food_waste"],
      general_trash_kpis: ["general_trash"],
      glass_kpis: ["glass"],
      leather_kpis: ["leather"],
      foam_kpis: ["foam_eva"],
      empty_cans_or_containers_not_dangerous_kpis: ["empty_cans_or_containers"],
      rubber_kpis: ["rubber"],
      other_non_hazardous_kpis: ["other_non_hazardous_waste"],
      total_non_hazardous_waste_kpis: null, // Calculado - suma de todos los no peligrosos
      total_non_hazardous_waste_unit_kpis: null, // Calculado

      // Residuos peligrosos
      electronic_waste_kpis: ["electronic_waste"],
      empty_chemical_containers_kpis: ["empty_chemical_containers"],
      cleaning_pesticide_containers_kpis: ["cleaning_pesticide_containers"],
      batteries_kpis: ["batteries"],
      fluorescent_tubes_kpis: ["fluorescent_tubes"],
      cooking_oil_kpis: ["cooking_oil"],
      maintenance_oil_kpis: ["maintenance_oil"],
      lubricants_kpis: ["lubricants"],
      paint_remains_kpis: ["paint_waste"],
      coal_ashes_kpis: ["coal_ashes"],
      rubber_hazardous_kpis: ["rubber_hazardous"],
      chemicals_kpis: ["chemicals"],
      contaminated_materials_kpis: ["contaminated_materials"],
      ink_cartridges_kpis: ["ink_cartridges"],
      medical_waste_kpis: ["medical_waste"],
      other_hazardous_waste_kpis: ["other_hazardous_waste"],
      total_hazardous_waste_kpis: null, // Calculado - suma de todos los peligrosos
      total_hazardous_waste_unit_kpis: null, // Calculado

      // Métodos de disposición - no peligrosos (siempre mostrar)
      reuse_recycling_rnp: null,
      composting_rnp: null,
      energy_recovery_rnp: null,
      incineration_no_energy_recovery_rnp: null,
      landfill_rnp: null,
      other_methods_rnp: null,

      // Métodos de disposición - peligrosos (siempre mostrar)
      reuse_recycling_rep: null,
      energy_recovery_rep: null,
      incineration_no_energy_recovery_rep: null,
      landfill_rep: null,
      other_methods_rep: null,
    };
    return kpiSourceMap[kpiName];
  }, []);

  // 🚀 Memoizar determinación de campos basándose en configFormData
  const determineFieldsKPIs = useMemo(() => {
    const fields = new Set();

    // Procesar KPIs de residuos
    Object.keys(wasteKPIsCodes).forEach((key) => {
      const sourceFields = getKPISourceFields(key);

      // Si no tiene campos fuente definidos (es calculado), agregarlo por defecto
      if (!sourceFields) {
        fields.add(key);
        return;
      }

      // Si hay configFormData, verificar si TODOS los campos fuente están activos
      if (configFormData?.fields && configFormData.fields.length > 0) {
        const allSourceFieldsActive = sourceFields.every((sourceFieldName) => {
          const fieldConfig = configFormData.fields.find(
            (f) => f.name === sourceFieldName,
          );
          return fieldConfig && fieldConfig.active !== false;
        });

        if (allSourceFieldsActive) {
          fields.add(key);
        }
      } else {
        // Si no hay configFormData, mostrar todos los campos (comportamiento por defecto)
        fields.add(key);
      }
    });

    // Agregar todos los métodos de disposición (siempre se muestran)
    Object.keys(disposalMethodCode).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  }, [configFormData, getKPISourceFields]);

  const determineFieldsCode = useMemo(() => {
    const fields = new Set();

    Object.keys(wasteCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  }, []);

  useEffect(() => {
    (async () => {
      // baselineLoaded (no solo valueBaseline, que arranca en {} y por lo
      // tanto es truthy desde el inicio) evita calcular con datos a medio
      // cargar mientras el fetch de línea base todavía está en vuelo.
      if (!data || !baselineLoaded) return;

      startLoading();
      try {
        // 1️⃣ Procesamos los datos crudos
        const { totalsPerYear, detailPerConceptBase } =
          await transformData1(data);

        // 2️⃣ Agrupamos los métodos según el tipo de residuo
        const groupedRnp = groupDisposalMethods(detailPerConceptBase, "rnp");
        const groupedRep = groupDisposalMethods(detailPerConceptBase, "rep");

        // groupedRnp y groupedRep comparten las mismas claves de residuo (concept),
        // por lo que hay que combinarlas por residuo en vez de hacer spread directo
        // (si no, rep pisa a rnp y se pierden grupos como composting_rnp)
        const groupedDisposals = {};
        for (const concept of new Set([
          ...Object.keys(groupedRnp),
          ...Object.keys(groupedRep),
        ])) {
          groupedDisposals[concept] = {
            ...groupedRnp[concept],
            ...groupedRep[concept],
          };
        }

        // 3️⃣ Calculamos datos finales
        await calculateDataFinal(totalsPerYear, groupedDisposals);

        // Detectar años sin baseline para mostrar aviso
        const currentYear = new Date().getFullYear();
        const yearsToCheck = [0,1,2,3,4].map(i => String(currentYear - i));
        setMissingBaselineYears(yearsToCheck.filter(y => !valueBaseline?.[y]));

        const lastFiveYears = [
          currentYear,
          currentYear - 1,
          currentYear - 2,
          currentYear - 3,
          currentYear - 4,
        ];

        // Filtrar datos de los últimos 5 años
        const filteredByYears = data?.data
          ?.filter((item) => lastFiveYears.includes(Number(item.year)))
          ?.reduce((acc, item) => {
            const year = Number(item.year);
            if (!acc[year]) acc[year] = [];
            acc[year].push(item);
            return acc;
          }, {});

        setLastYears(lastFiveYears);

        const results = await getLastThreeYearsData(filteredByYears);
        setTotalesByFilters(results);

        // Usar producción compartida desde DashBoard.js
        if (sharedProductionForms) {
          const totalesFinal = await calcularVPSVFSporMesPorAño(sharedProductionForms, baseline);
          setTotalesProductionsByFilters(totalesFinal);
        }
      } catch (error) {
        console.error("Error processing waste data:", error);
      } finally {
        stopLoading();
      }
    })();
  }, [data, valueBaseline, baselineLoaded, sharedProductionForms]);
  /* }
      } catch (error) {
        //console.error(error);
      }finally {
        stopLoading();
      }
    })();
  }, [data, valueBaseline, sharedProductionForms]);*/

  //Calcula el valor de linea base por año hay que cambiar si es por vfs o vps
  const getValueBaseLine = async (year, type) => {
    try {
      if (type === "VPS") {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_production",
          );
        //setValueBaseline(response1.total)
        return response1.total;
      } else {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_billing",
          );
        //setValueBaseline(response1.total)
        return response1.total;
      }
    } catch (error) {
      //console.error(error);
      return 1;
    }
  };

  async function calcularVPSVFSporMesPorAño(documentosPorAño, baselines) {
    const resultado = {};

    for (const [year, docs] of Object.entries(documentosPorAño)) {
      const baselineType = baselines[year]; // "VPS" o "VFS"
      if (!baselineType) continue;

      const isProduccion = baselineType === "VPS";
      const prefix = isProduccion ? "VP" : "VF";

      resultado[year] = {};

      for (const doc of docs) {
        const mes = doc.period;
        if (!mes) continue;

        let totalMes = 0;

        // Recorremos todos los campos del documento
        for (const [key, campo] of Object.entries(doc)) {
          // buscamos solo los campos dinámicos de producción o facturación
          if (
            campo?.code &&
            campo.code.startsWith(prefix) &&
            !campo.code.startsWith(prefix + "S")
          ) {
            const value = Number(campo.value) || 0;
            const coef = Number(campo.standardized_coefficient) || 1;
            totalMes += value * coef;
          }
        }

        resultado[year][mes] = totalMes;
      }
    }

    return resultado;
  }

  // 🔹 1. Procesa los datos base y guarda los métodos individuales (Met1–Met10)
  const transformData1 = async (data) => {
    const totalsPerYear = {};
    const detailPerConceptBase = {}; // 👈 Detalle por residuo/método
    const conceptsSet = [];
    const unitsCache = {};

    // Unidades configuradas en configFormData tienen prioridad máxima
    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    const fields = determineFieldsCode; // 🚀 Usar directamente el array memoizado

    if (!data || !Array.isArray(data.data) || data.data.length === 0) return {};

    const uniqueYears = [
      ...new Set(data.data.map((item) => String(item.year))),
    ];

    // Obtener unidades por año
    const promises = uniqueYears.map(async (year) => {
      try {
        const units = await wasteController.getLastUnitFieldsByYear(
          accessToken,
          site,
          year,
          fields,
        );
        if (units && units.fields) unitsCache[year] = units;
      } catch (error) {
        console.error(`Error al obtener unidades para el año ${year}:`, error);
      }
    });

    await Promise.all(promises);

    // Procesar los datos de consumo
    if (data.data) {
      const consumptionPromises = data.data.map(async (item) => {
        const year = String(item.year);
        const units = unitsCache[year];
        if (!units) return;

        fields.forEach((concept) => {
          if (!item[concept]) return;
          conceptsSet.push(concept);

          if (!totalsPerYear[concept]) totalsPerYear[concept] = {};
          if (!totalsPerYear[concept][year])
            totalsPerYear[concept][year] = {
              total: 0,
              unit: configUnits[concept] || units.fields[concept] || item[concept]?.unit || "",
            };
          // if (year === "2024" && concept === "paper_and_cardboard") {
          //   console.log(concept, item[concept].value, year);
          // }

          const convertedValue = item[concept].value
            ? convertUnitsFinal(
                item[concept].value,
                item[concept].unit,
                totalsPerYear[concept][year].unit,
                concept,
              )
            : 0;

          totalsPerYear[concept][year].total += convertedValue;

          // ---- Capturar el método de disposición ----
          const method = item[concept]?.disposalMethod;
          if (!method) return;

          if (!detailPerConceptBase[concept])
            detailPerConceptBase[concept] = {};
          if (!detailPerConceptBase[concept][method])
            detailPerConceptBase[concept][method] = {};
          if (!detailPerConceptBase[concept][method][year]) {
            detailPerConceptBase[concept][method][year] = {
              total: 0,
              unit: totalsPerYear[concept][year].unit || "",
            };
          }

          detailPerConceptBase[concept][method][year].total += convertedValue;
        });
      });

      await Promise.all(consumptionPromises);
    }

    return { totalsPerYear, detailPerConceptBase };
  };

  const groupDisposalMethods = (detailBase, type = "rnp") => {
    console.log(
      `🔍 groupDisposalMethods (${type}) - detailBase entrada:`,
      detailBase,
    );

    // Validar que detailBase no sea null o undefined
    if (!detailBase || typeof detailBase !== "object") {
      console.log(
        `⚠️ groupDisposalMethods (${type}) - detailBase es null/undefined, retornando {}`,
      );
      return {};
    }

    // 🔹 Mapa de agrupaciones basado en key (Met#)
    const groupByKey =
      type === "rep"
        ? {
            reuse_recycling_rep: ["reuse", "recycling"], // Reutilizados y reciclados
            energy_recovery_rep: [
              "energy_recovery",
              "incineration_non_recyclable_waste_energy_recovery",
              "incineration_recyclable_waste_energy_recovery",
            ], // Recuperación de energía
            incineration_no_energy_recovery_rep: [
              "incineration_without_energy_recovery",
            ], // Incinerados sin recuperación
            landfill_rep: [
              "landfill_control_measures",
              "non_controlled_sanitary_filling",
            ], // Vertederos
            other_methods_rep: ["others"], // Otros
          }
        : {
            // reuse_recycling_rnp: ["Met1", "Met2"], // Reutilizados y reciclados
            reuse_recycling_rnp: ["reuse", "recycling"], // Reutilizados y reciclados
            composting_rnp: ["composting"], // Compostaje
            energy_recovery_rnp: [
              "incineration_non_recyclable_waste_energy_recovery",
              //"landfill_control_measures",
              "incineration_recyclable_waste_energy_recovery",
            ], // Recuperación de energía
            incineration_no_energy_recovery_rnp: [
              "incineration_without_energy_recovery",
            ], // Incinerados sin recuperación
            landfill_rnp: [
              "landfill_control_measures",
              "non_controlled_sanitary_filling",
            ], // Vertederos
            other_methods_rnp: ["others"], // Otros
          };

    const grouped = {};

    // 🔧 FIX (revisión KPIs residuos): esta función se llama una vez con type="rnp"
    // y otra con type="rep" (ver useEffect más arriba). Antes NO filtraba qué
    // conceptos procesaba en cada llamada -- recorría TODOS los conceptos
    // (peligrosos y no peligrosos mezclados) en ambas pasadas. Como resultado,
    // un concepto no peligroso (ej. "paper_and_cardboard") también generaba
    // entradas "_rep" (reuse_recycling_rep, landfill_rep, etc.) con los MISMOS
    // valores crudos que sus entradas "_rnp", y como ambas se traducen al mismo
    // texto ("Reutilizados y reciclados", "Vertederos / Relleno sanitario"), la
    // tabla mostraba la fila duplicada con los mismos números. Se agrega un
    // filtro para que cada llamada solo procese los conceptos que corresponden
    // a ese tipo de residuo.
    const NON_HAZARDOUS_WASTE_FIELDS = [
      "paper_and_cardboard",
      "plastic",
      "fabric_scraps",
      "metal_clean",
      "wood",
      "food_waste",
      "general_trash",
      "glass",
      "leather",
      "foam_eva",
      "empty_cans_or_containers",
      "rubber",
      "other_non_hazardous_waste",
    ];
    const HAZARDOUS_WASTE_FIELDS = [
      "electronic_waste",
      "empty_chemical_containers",
      "cleaning_pesticide_containers",
      "batteries",
      "fluorescent_tubes",
      "cooking_oil",
      "maintenance_oil",
      "lubricants",
      "paint_waste",
      "coal_ashes",
      "rubber_hazardous",
      "chemicals",
      "contaminated_materials",
      "ink_cartridges",
      "medical_waste",
      "other_hazardous_waste",
    ];
    const allowedConcepts =
      type === "rep" ? HAZARDOUS_WASTE_FIELDS : NON_HAZARDOUS_WASTE_FIELDS;

    // Bloque original, comentado por las dudas:
    // Object.entries(detailBase).forEach(([conceptKey, methods]) => {
    //   grouped[conceptKey] = {};
    //
    //   Object.entries(groupByKey).forEach(([groupKey, methodList]) => {
    //     grouped[conceptKey][groupKey] = {};
    //
    //     methodList.forEach((methodKey) => {
    //       if (!methods[methodKey]) return;
    //
    //       Object.entries(methods[methodKey]).forEach(([year, val]) => {
    //         console.log(
    //           `📊 ${type} | ${groupKey} | método: ${methodKey} | año: ${year} | total: ${val.total} ${val.unit}`,
    //         );
    //
    //         if (!grouped[conceptKey][groupKey][year])
    //           grouped[conceptKey][groupKey][year] = {
    //             total: 0,
    //             unit: val.unit,
    //           };
    //
    //         grouped[conceptKey][groupKey][year].total += val.total;
    //       });
    //     });
    //   });
    // });

    // 🔹 Iterar sobre conceptos (planta, tipo de residuo, etc.)
    Object.entries(detailBase).forEach(([conceptKey, methods]) => {
      if (!allowedConcepts.includes(conceptKey)) return; // 🔧 evita mezclar conceptos rnp/rep

      grouped[conceptKey] = {};

      Object.entries(groupByKey).forEach(([groupKey, methodList]) => {
        grouped[conceptKey][groupKey] = {};

        methodList.forEach((methodKey) => {
          if (!methods[methodKey]) return;

          Object.entries(methods[methodKey]).forEach(([year, val]) => {
            console.log(
              `📊 ${type} | ${groupKey} | método: ${methodKey} | año: ${year} | total: ${val.total} ${val.unit}`,
            );

            if (!grouped[conceptKey][groupKey][year])
              grouped[conceptKey][groupKey][year] = {
                total: 0,
                unit: val.unit,
              };

            grouped[conceptKey][groupKey][year].total += val.total;
          });
        });
      });
    });

    console.log(
      `✅ groupDisposalMethods (${type}) - resultado agrupado:`,
      grouped,
    );
    return grouped;
  };

  // 🔹 3. Calcular datos finales dividiendo por producción o empleados
  // const calculateDataFinal = (
  //   totalsPerYear,
  //   groupedDetail,
  //   productionOrEmployeeByYear
  // ) => {
  //   const finalTotals = { ...totalsPerYear };
  //   const finalGrouped = {};

  //   Object.entries(groupedDetail).forEach(([concept, categories]) => {
  //     finalGrouped[concept] = {};

  //     Object.entries(categories).forEach(([category, yearsData]) => {
  //       finalGrouped[concept][category] = {};

  //       Object.entries(yearsData).forEach(([year, val]) => {
  //         const divisor = productionOrEmployeeByYear[year] || 1;
  //         finalGrouped[concept][category][year] = {
  //           total: val.total / divisor,
  //           unit: `${val.unit}/unidad`,
  //         };
  //       });
  //     });
  //   });

  //   // Finalmente, guardar todo
  //   setTotales(finalTotals);
  //   setDetailPerConceptGrouped(finalGrouped);
  // };

  const calculateDataFinal = async (totalsPerYear, disposals) => {
    const totalesFinal = { ...totalsPerYear };
    const conceptosSet = [];

    // 1️⃣ Calcular indicadores principales
    //
    // 🔧 FIX (revisión KPIs residuos): el gate "evitar cálculos con datos inválidos"
    // validaba totalesFinal[item][year] -- es decir, los datos del `item` del loop
    // EXTERNO (un concepto cualquiera sin relación) -- en vez de validar la fuente
    // real del `concepto` que se estaba por calcular en el forEach interno. Eso podía
    // saltear el cálculo de un KPI por culpa de que OTRO campo, sin relación, diera
    // 0/inválido ese año. Se reemplaza por una validación que usa getKPISourceFields(concepto)
    // para chequear el/los campo(s) fuente reales de ESE concepto. Se mantiene la
    // protección contra crashes (wasteFormulasIndicators accede a data[campo]?.[year].total,
    // que puede explotar si el año no existe para ese campo).
    //
    // Bloque original, comentado por las dudas:
    // if (totalesFinal) {
    //   for (const item in totalesFinal) {
    //     if (!totalesFinal.hasOwnProperty(item)) continue;
    //
    //     for (const year in totalesFinal[item]) {
    //       const valueB = valueBaseline[year];
    //       const fields = determineFieldsKPIs; // 🚀 Usar directamente el array memoizado
    //
    //       fields.forEach((concepto) => {
    //         if (!totalesFinal[concepto]) {
    //           totalesFinal[concepto] = {};
    //           conceptosSet.push(concepto);
    //         }
    //
    //         if (!totalesFinal[concepto][year]) {
    //           totalesFinal[concepto][year] = {};
    //         }
    //
    //         const baseData = totalesFinal[item]?.[year];
    //         // ⚠️ Evitar cálculos con datos inválidos
    //         if (
    //           !baseData ||
    //           baseData.total === 0 ||
    //           baseData.unit === "" ||
    //           baseData.total === null ||
    //           isNaN(baseData.total)
    //         ) {
    //           return; // salta el cálculo
    //         }
    //
    //         // ✅ Calcular el indicador KPI
    //         totalesFinal[concepto][year] = wasteFormulasIndicators(
    //           concepto,
    //           year,
    //           totalesFinal,
    //           valueB === 0 ? 1 : valueB,
    //           workersTotals?.[year],
    //         );
    //       });
    //     }
    //   }
    // }

    if (totalesFinal) {
      // Recolectar los años presentes en los datos crudos (antes de agregar las claves de KPIs)
      const allYears = new Set();
      for (const item in totalesFinal) {
        for (const year in totalesFinal[item]) {
          allYears.add(year);
        }
      }

      const fields = determineFieldsKPIs; // 🚀 Usar directamente el array memoizado

      fields.forEach((concepto) => {
        // Campo(s) fuente (raw) que alimentan este KPI; null = KPI calculado sin fuente propia
        const sourceFields = getKPISourceFields(concepto);

        allYears.forEach((year) => {
          if (!totalesFinal[concepto]) {
            totalesFinal[concepto] = {};
            conceptosSet.push(concepto);
          }

          if (!totalesFinal[concepto][year]) {
            totalesFinal[concepto][year] = {};
          }

          const valueB = valueBaseline[year];

          // ⚠️ Evitar cálculos con datos inválidos: se valida la fuente real del propio
          // concepto (no la de otro item del loop, que no tiene relación con este cálculo)
          const isSourceDataValid = !sourceFields
            ? true
            : sourceFields.every((sourceFieldName) => {
                const baseData = totalesFinal[sourceFieldName]?.[year];
                return (
                  baseData &&
                  baseData.total !== 0 &&
                  baseData.unit !== "" &&
                  baseData.total !== null &&
                  !isNaN(baseData.total)
                );
              });

          if (!isSourceDataValid) return; // salta el cálculo

          // ✅ Calcular el indicador KPI
          totalesFinal[concepto][year] = wasteFormulasIndicators(
            concepto,
            year,
            totalesFinal,
            valueB === 0 ? 1 : valueB,
            workersTotals?.[year],
          );
        });
      });
    }

    // 1️⃣.1 Totales de métodos de disposición (reuse_recycling_rnp, composting_rnp,
    // etc.): wasteFormulasIndicators para estos códigos espera una estructura
    // intermedia (data["reuse"][year]["rnp"]) que este pipeline nunca llega a
    // poblar, así que el cálculo de arriba les da siempre 0/undefined. Acá se
    // pisan con el total real: sumar, para cada método agrupado, su valor a
    // través de todos los tipos de residuo — la misma fuente (`disposals`,
    // agrupada por tipo de residuo → método → año) que ya usa correctamente
    // el gráfico de torta.
    const disposalGroupKeys = new Set();
    for (const wasteType in disposals) {
      for (const groupKey in disposals[wasteType]) {
        disposalGroupKeys.add(groupKey);
      }
    }
    disposalGroupKeys.forEach((groupKey) => {
      totalesFinal[groupKey] = {};
      for (const wasteType in disposals) {
        const entryByYear = disposals[wasteType]?.[groupKey];
        if (!entryByYear) continue;
        for (const year in entryByYear) {
          const { total, unit } = entryByYear[year];
          if (!total) continue;
          if (!totalesFinal[groupKey][year]) {
            totalesFinal[groupKey][year] = { total: 0, unit: unit || "" };
          }
          totalesFinal[groupKey][year].total += total;
          if (!totalesFinal[groupKey][year].unit && unit) {
            totalesFinal[groupKey][year].unit = unit;
          }
        }
      }
    });

    // 2️⃣ Calcular valores normalizados y mantener valores originales
    const disposalNormalized = {};
    const disposalRaw = {}; // 🔹 Nueva estructura para guardar los valores originales

    for (const wasteType in disposals) {
      const wasteData = disposals[wasteType];
      disposalNormalized[wasteType] = {};
      disposalRaw[wasteType] = {};

      for (const method in wasteData) {
        const methodData = wasteData[method];
        disposalNormalized[wasteType][method] = {};
        disposalRaw[wasteType][method] = {};

        for (const year in methodData) {
          const { total, unit } = methodData[year];
          const valueB = valueBaseline[year] || 1;
          const workers = workersTotals?.[year] || 1;

          // ⚠️ Evitar dividir si no hay datos válidos
          if (!total || total === 0 || !unit || unit === "") continue;

          // 🔹 Guardar valor original (para la dona u otros cálculos)
          disposalRaw[wasteType][method][year] = { total, unit };

          // 🔸 Elegir divisor (según tu lógica)
          const divisor = unit.includes("kg") ? valueB : workers;
          const normalizedValue = total / (divisor === 0 ? 1 : divisor);

          // 🔹 Guardar valor normalizado
          disposalNormalized[wasteType][method][year] = {
            total: normalizedValue,
            unit,
          };
        }
      }
    }

    // 👉 Después de este bloque, tendrás:
    // disposalRaw → valores originales (para la dona)
    // disposalNormalized → valores divididos (para indicadores)

    // 3️⃣ Combinar todo
    // const finalData = {
    //   ...totalesFinal,
    //   ...disposalNormalized,
    // };

    setConceptos(conceptosSet);
    setTotales(totalesFinal);
    setDataDetailPerConcept(disposalNormalized);
    setDataDisposalRaw(disposalRaw);
  };

  // Función para obtener los valores de un año y mes específicos (period en texto)
  const getDataByYearAndMonth = async (data, year, month) => {
    const results = {};
    const fields = determineFieldsCode; // 🚀 Usar directamente el array memoizado
    const unitsCache = {};

    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    if (!data || !data || Object.keys(data).length === 0) {
      return {};
    }

    // Diccionario de meses
    const monthMap = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const yearStr = String(year);
    const monthStr =
      typeof month === "string"
        ? monthMap[month] || ""
        : String(month).padStart(2, "0");

    if (!monthStr) {
      console.warn("Mes inválido o no reconocido:", month);
      return {};
    }

    const yearData = data[yearStr];
    if (!Array.isArray(yearData)) {
      console.warn("No hay datos para el año:", yearStr);
      return {};
    }

    const filteredData = yearData.filter(
      (item) => monthMap[item.period] === monthStr,
    );

    if (filteredData.length === 0) {
      console.warn(`No hay datos para ${month} ${yearStr}`);
      return {};
    }

    // Procesar resultados por campo
    filteredData.forEach((item) => {
      const units = unitsCache[yearStr];

      fields.forEach((concept) => {
        if (item[concept]) {
          if (!results[concept]) {
            results[concept] = {
              total: 0,
              unit: configUnits[concept] || units?.fields[concept] || item[concept]?.unit || "",
            };
          }

          results[concept].total += item[concept].value
            ? convertUnitsFinal(
                item[concept].value,
                item[concept].unit,
                results[concept].unit,
                concept,
              )
            : 0;
        }
      });
    });

    // ==========================
    // 🔹 Calcular energía total (sin incluir costos)
    // ==========================

    // Lista de conceptos energéticos (sin costos)
    const wasteConcepts = Object.keys(wasteCodes).filter(
      (key) => !key.includes("cost"),
    );

    let totalWasteMonth = 0;
    let wasteUnit = "";

    wasteConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        totalWasteMonth += results[concept].total;
        wasteUnit = results[concept].unit || wasteUnit;
      }
    });

    results.total_waste_month = {
      total: totalWasteMonth,
      unit: wasteUnit || "MWh",
    };

    // ==========================
    // 🔹 Calcular renovables
    // ==========================

    // ==========================
    // 🔹 Calcular electrica
    // ==========================
    return results;
  };

  // ==========================
  // 🔹 Calcular ultimos 3 años
  // ==========================

  const getLastThreeYearsData = async (totalesByFilters) => {
    const currentYear = new Date().getFullYear();
    const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const resultsByYear = {};

    for (const year of lastThreeYears) {
      resultsByYear[year] = {};

      for (const month of months) {
        const data = await getDataByYearAndMonth(totalesByFilters, year, month);
        resultsByYear[year][month] = data;
      }
    }

    return resultsByYear;
  };

  const removeNulls = (data, concepts) => {
    // Iterar sobre las claves externas
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        // Verificar si todos los valores internos son 0
        const allZero = Object.values(data[key]).every(
          (value) =>
            value.total === 0 ||
            value.total === undefined ||
            isNaN(value.total),
        );

        // Si todos los valores son 0, eliminar la clave externa
        if (allZero) {
          //delete concepts[key];
          concepts = concepts.filter((item) => item !== key);
        }
      }
    }
    return concepts;
  };

  const summaryRef = useRef();
  const tableGrafRef = useRef();
  const comparisonChartRef = useRef();
  const comparisonPeligrososRef = useRef();

  const yearsWithData = useMemo(() => {
    if (!data?.years || !conceptos || conceptos.length === 0) return [];
    return [...data.years]
      .sort((a, b) => b - a)
      .filter(year =>
        conceptos.some(item => (totales[item]?.[year]?.total || 0) !== 0)
      );
  }, [data, conceptos, totales]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (
    !data ||
    !data.years ||
    data.years.length === 0 ||
    !conceptos ||
    conceptos.length === 0
  ) {
    return (
      <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
        <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
          <Icon name="exclamation triangle" size="huge" color="gray" />
        </div>
        <div
          style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
        >
          {t("no_data_available") || "No hay datos disponibles"}
        </div>
      </div>
    );
  } else {
    const exportYears = data?.years ? [...data.years].sort((a, b) => Number(b) - Number(a)).slice(0, 5) : [];

    // Grupos para el PDF — misma lógica que TableYears
    const getWasteGroup = (code) => {
      if (!code) return null;
      if (/^KPIrnp\d+$/.test(code)) {
        const n = parseInt(code.replace("KPIrnp", ""), 10);
        if (n >= 1 && n <= 15) return "Residuos No Peligrosos";
      }
      if (/^KPIrep\d+$/.test(code)) {
        const n = parseInt(code.replace("KPIrep", ""), 10);
        if (n >= 1 && n <= 18) return "Residuos Peligrosos";
      }
      return null;
    };
    const wasteExportGroups = (() => {
      const acc = {};
      conceptos.forEach((item) => {
        const kpiCode = wasteKPIsCodes[item];
        const dispCode = disposalMethodCode?.[item];
        const rawCode = kpiCode || dispCode;
        // Excluir métodos de disposición
        const match = rawCode?.match(/KPI(rnp|rep)(\d+)/);
        if (match) {
          const [, tipo, num] = match;
          const n = parseInt(num, 10);
          if ((tipo === "rnp" && n >= 16) || (tipo === "rep" && n >= 19)) return;
        }
        const group = getWasteGroup(kpiCode) || "Otros";
        if (!acc[group]) acc[group] = [];
        acc[group].push(item);
      });
      return Object.entries(acc)
        .filter(([g]) => g !== "Otros")
        .map(([label, items]) => ({ label, items }));
    })();

    // Grupo de métodos de disposición para el PDF, con sus valores ya
    // convertidos a % sobre el total del grupo (mismo criterio que la tabla
    // en pantalla, TableYears): se arma un `totales` sintético solo para
    // estos ítems (unit "%"), sin tocar el `totales` real que usa el resto
    // del dashboard.
    const normalizeToKgExport = (value, unit) => {
      if (!value || isNaN(value)) return 0;
      switch (unit) {
        case "t":
        case "ton": return value * 1000;
        case "g": return value / 1000;
        case "kg":
        default: return value;
      }
    };

    const disposalExportGroups = (() => {
      const acc = {};
      conceptos.forEach((item) => {
        const code = disposalMethodCode?.[item];
        if (!code) return;
        const match = code.match(/KPI(rnp|rep)(\d+)/);
        if (!match) return;
        const [, tipo, num] = match;
        const n = parseInt(num, 10);
        const isDisposal = (tipo === "rnp" && n >= 16 && n <= 21) || (tipo === "rep" && n >= 19 && n <= 23);
        if (!isDisposal) return;
        const label = tipo === "rnp" ? "Métodos Disposición - No Peligrosos" : "Métodos Disposición - Peligrosos";
        if (!acc[label]) acc[label] = [];
        acc[label].push(item);
      });
      return Object.entries(acc).map(([label, items]) => ({ label, items }));
    })();

    const disposalPercentTotales = {};
    disposalExportGroups.forEach(({ items }) => {
      const groupYearTotals = {};
      exportYears.forEach((yr) => {
        groupYearTotals[yr] = items.reduce((sum, item) => {
          const entry = totales[item]?.[yr];
          return sum + normalizeToKgExport(entry?.total || 0, entry?.unit);
        }, 0);
      });
      items.forEach((item) => {
        disposalPercentTotales[item] = {};
        exportYears.forEach((yr) => {
          const entry = totales[item]?.[yr];
          const raw = normalizeToKgExport(entry?.total || 0, entry?.unit);
          const groupTotal = groupYearTotals[yr];
          disposalPercentTotales[item][yr] = {
            total: groupTotal > 0 ? (raw / groupTotal) * 100 : null,
            unit: "%",
          };
        });
      });
    });

    const wasteExportGroupsWithDisposal = [...wasteExportGroups, ...disposalExportGroups];
    const totalesForExport = { ...totales, ...disposalPercentTotales };
    const codesForExport = { ...wasteKPIsCodes, ...disposalMethodCode };

    // Umbral de magnitud para inferir Regla 1 (entero) en la tabla del PDF
    // — mismo criterio que resolveRowRule más abajo (tabla en pantalla).
    const PDF_WASTE_WHOLE_NUMBER_THRESHOLD = 100;

    // AJUSTES DE MAGNITUDES NUMÉRICAS aplicado a la tabla del PDF (antes
    // usaba `toFixed(2)` fijo + coma decimal). Costos e ítems grandes ->
    // Regla 1, el resto -> Regla 2+ adaptativa; los % de métodos de
    // disposición (disposalPercentTotales, ya en escala 0-100) van sin el
    // símbolo "%" porque la columna "Unidades" ya lo indica.
    const formatWasteCellForPdf = (value, item, unit) => {
      if (typeof value !== "number" || isNaN(value) || value === 0) return "-";
      let formatted;
      if (unit === "%") {
        formatted = formatMagnitude(value, 2);
      } else {
        const rowValues = Object.values(totalesForExport[item] || {})
          .map((entry) => entry?.total)
          .filter((v) => typeof v === "number" && !isNaN(v) && v !== 0)
          .map(Math.abs);
        const isWhole = item.includes("cost") || (rowValues.length > 0 && Math.max(...rowValues) >= PDF_WASTE_WHOLE_NUMBER_THRESHOLD);
        formatted = isWhole ? formatWhole(value) : formatMagnitudeAdaptive(value);
      }
      // autoTable dibuja esta celda con doc.text() nativo (no SVG) — el
      // espacio fino (U+202F) de formatWhole/formatMagnitude(Adaptive) no
      // existe en WinAnsi y rompe el texto (mismo problema ya resuelto en
      // GEI/Social).
      return formatted.replace(/ /g, " ");
    };

    return (
      <div className="list-waste-forms">

        {/* Aviso cuando hay años sin baseline VPS/VFS */}
        {missingBaselineYears.length > 0 && (
          <div style={{
            background: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "6px",
            padding: "10px 16px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "0.92em",
          }}>
            <Icon name="warning sign" color="yellow" />
            <span>
              Algunos indicadores (KPIs) para los años <strong>{missingBaselineYears.join(", ")}</strong> mostrarán valor 0. Configurá el volumen producido (VPS) o el volumen facturado (VFS) como línea base para verlos correctamente.{" "}
              <Link to="/admin/data/productionforms" style={{ color: "#856404", fontWeight: "bold" }}>
                Configurar línea base →
              </Link>
            </span>
          </div>
        )}

        {/* Sección de Resumen */}
        <div className="waste-summary-section" ref={summaryRef}>
          <WasteSummary
            filters={filters}
            site={site}
            valueBaseline={valueBaseline}
            baselineLoaded={baselineLoaded}
            wasteController={Wasteform}
            totales={totales}
            totalesMethods={dataDisposalRaw}
            selectorSlot={<YearMonthSelector onChange={setFilters} availableYears={yearsWithData} />}
            exportSlot={
              <KPIExportIconButton
                title={t("waste") || "Residuos"}
                conceptos={conceptos}
                years={exportYears}
                totales={totalesForExport}
                codes={codesForExport}
                t={t}
                sectionGroups={wasteExportGroupsWithDisposal}
                formatCellValue={formatWasteCellForPdf}
                methodColumn={{
                  header: t("disposalMethod") || "Método de disposición",
                  getValue: () => t("total") || "Total",
                }}
                chartRefs={[
                  { ref: summaryRef, label: t("summary") || "Resumen" },
                ]}
                renderCustomCharts={(doc, exportCtx) =>
                  drawWasteCustomCharts(doc, exportCtx, {
                    totales,
                    totalesMethods: dataDisposalRaw,
                    filters,
                    valueBaseline,
                    t,
                  })
                }
                siteName={siteName}
              />
            }
          />
        </div>

        {/* Sección de Gráficos */}
        <div className="waste-tablegraf-section" ref={tableGrafRef}>
          <TableGraf
            filters={filters}
            totales={totales}
            t={t}
            totalesMethods={dataDisposalRaw}
          />
        </div>

        {/* Sección de Comparación - No Peligrosos */}
        <CollapsibleSection
          title={t("composition_non_hazardous_waste_generation")}
          className="waste-comparison-section"
          ref={comparisonChartRef}
        >
          <WasteComparisonChart
            resultsByYear={totales}
            t={t}
            valueBaseline={valueBaseline}
          />
        </CollapsibleSection>

        {/* Sección de Comparación - Peligrosos */}
        <CollapsibleSection
          title={t("composition_hazardous_waste_generation")}
          className="waste-comparison-section"
          ref={comparisonPeligrososRef}
        >
          <WasteComparisonChartPeligrosos
            resultsByYear={totales}
            t={t}
            valueBaseline={valueBaseline}
          />
        </CollapsibleSection>

        {/* Sección de Tabla de Datos */}
        <TableYears
          filters={filters}
          data={data}
          accessToken={accessToken}
          t={t}
          conceptos={conceptos}
          totales={totales}
          language={language}
          indicatorsLineBase={indicatorsLineBase}
          valueBaseline={valueBaseline}
          detailPerConcept={dateDetailPerConcept}
          unitsRecorded={unitsRecorded}
          role={role}
          defaultOpen={true}
        />

        {/* Sección de Valores Intermedios */}
        {/* <IntermediateValuesDisplay
          resultsProductions={totalesProductionsByFilters}
          resultsWorkers={workersTotalsByPeriod}
          t={t}
        /> */}
      </div>
    );
  }
}

function TableYears(props) {
  const {
    data,
    conceptos,
    totales,
    t,
    language,
    valueBaseline,
    indicatorsLineBase,
    filters,
    detailPerConcept,
    unitsRecorded, // ✅ Nuevo prop con unidades guardadas
    role,
    defaultOpen = true,
  } = props;

  const { year, month } = filters || {};
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [years, setYears] = useState([]);
  const [months, setMoths] = useState([]);
  const [listConceptos, setListConceptos] = useState([]);

  //const [uniqueFields, setUniqueFields] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState({});

  // Función comentada porque la conversión de unidades está deshabilitada
  // const handleUnitChange = (rowIndex, newValue) => {
  //   setSelectedUnits({ ...selectedUnits, [rowIndex]: newValue.value });
  // };

  useEffect(() => {
    (async () => {
      try {
        setYears(data.years ? data.years.sort((a, b) => b - a) : []);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [data]);

  // ✅ Modificado para tomar las unidades de TOTALES (ya calculadas)
  useEffect(() => {
    (async () => {
      try {
        // console.log("🔄 WasteKPIsDashBoard: Actualizando selectedUnits...");
        // console.log("📋 totales recibido:", totales);
        // console.log("📋 conceptos:", conceptos);
        // console.log("📋 year actual:", year);

        const valor = {};
        conceptos.forEach((field) => {
          // 1. PRIORIDAD 1: Tomar la unidad de los totales calculados para el año actual
          if (
            totales &&
            totales[field] &&
            totales[field][year] &&
            totales[field][year].unit
          ) {
            valor[field] = totales[field][year].unit;
            console.log(
              `✅ ${field}: usando unidad de totales[${year}] = ${totales[field][year].unit}`,
            );
          }
          // 2. Si no hay en el año actual, intentar obtener del primer año disponible
          else if (totales && totales[field]) {
            const years = Object.keys(totales[field]);
            if (years.length > 0 && totales[field][years[0]]?.unit) {
              valor[field] = totales[field][years[0]].unit;
              console.log(
                `⚠️ ${field}: usando unidad del primer año (${years[0]}) = ${
                  totales[field][years[0]].unit
                }`,
              );
            } else {
              // 3. Usar unidad por defecto
              const defaultUnit = determineWasteUnits(field)[0]?.value || "kg";
              valor[field] = defaultUnit;
              console.log(
                `⚠️ ${field}: usando unidad por defecto = ${defaultUnit}`,
              );
            }
          } else {
            // 4. No hay datos en totales, usar unidad por defecto
            const defaultUnit = determineWasteUnits(field)[0]?.value || "kg";
            valor[field] = defaultUnit;
            console.log(
              `⚠️ ${field}: no hay datos en totales, usando por defecto = ${defaultUnit}`,
            );
          }
        });

        //console.log("📊 selectedUnits final:", valor);
        setSelectedUnits(valor);
      } catch (error) {
        console.error("❌ Error al cargar unidades:", error);
        setSelectedUnits({});
      }
    })();
  }, [conceptos, totales, year]); // ✅ Depende de totales y year

  useEffect(() => {
    (async () => {
      try {
        setListConceptos(conceptos);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [conceptos]);

  // Función para obtener el icono de aumento o disminución
  const getComparativeIcon = (currentYear, previousYear) => {
    if (previousYear !== null) {
      if (currentYear > previousYear) {
        return <Icon disabled name="angle up" color="green" />; // Aumento
      } else if (currentYear < previousYear) {
        return <Icon disabled name="angle down" color="red" />; // Disminución
      } else if (currentYear === previousYear) {
        return <span style={{ color: "blue", fontWeight: "bold" }}>=</span>;
      }
    }
    return null; // Sin cambio
  };

  // Función para convertir unidades automáticamente para mejor legibilidad
  const autoConvertUnits = (value, unit) => {
    // Convertir kg a g si el valor es < 1 (valores muy pequeños)
    if (unit === "kg" && value < 1 && value > 0) {
      return {
        value: value * 1000, // Convertir kg a g (1 kg = 1000 g)
        unit: "g",
      };
    }

    // Convertir ton a kg si el valor es >= 1000 (valores muy grandes en ton)
    if (unit === "ton" && value >= 1000) {
      return {
        value: value * 1000, // Convertir ton a kg (1 ton = 1000 kg)
        unit: "kg",
      };
    }

    // Convertir m³ a l si el valor es < 1
    if (unit === "m3" && value < 1 && value > 0) {
      return {
        value: value * 1000, // Convertir m³ a litros (1 m³ = 1000 L)
        unit: "l",
      };
    }

    return { value, unit };
  };

  // Función para obtener el icono de aumento o disminución
  const getIndicators = (item) => {
    let result = indicatorsLineBase.find((value) => value.name === item);
    if (result) {
      return result?.yearBaseline || 0;
    }
    return 0; // Sin cambio
  };

  // Umbral de magnitud para inferir Regla 1 (entero) en filas sin regla explícita
  const WHOLE_NUMBER_THRESHOLD = 100;

  // Determina la regla de la fila por magnitud: costos y valores grandes -> Regla 1
  // (entero, espacio fino de miles); el resto -> Regla 2/2+ adaptativa
  const resolveRowRule = (item, values) => {
    if (item.includes("cost")) return "whole";
    const nonZero = values
      .filter((v) => typeof v === "number" && !isNaN(v) && v !== 0)
      .map(Math.abs);
    if (nonZero.length === 0) return "adaptive";
    return Math.max(...nonZero) >= WHOLE_NUMBER_THRESHOLD ? "whole" : "adaptive";
  };

  // Formatea un valor según la regla resuelta para su fila
  const formatByRowRule = (rule, value) => {
    if (typeof value !== "number" || isNaN(value) || value === 0) return "-";
    return rule === "whole" ? formatWhole(value) : formatMagnitudeAdaptive(value);
  };

  const renderPill = (rule, displayValue, prevDisplayValue) => {
    const numValue = displayValue != null ? Number(displayValue) : null;
    const numPrev = prevDisplayValue != null ? Number(prevDisplayValue) : null;

    if (numValue == null || numValue === 0) {
      return <span className="gei-value-pill pill-empty" />;
    }

    let pillClass;
    if (numPrev == null || numPrev === 0) {
      pillClass = "pill-neutral";
    } else if (numValue > numPrev) {
      pillClass = "pill-up";
    } else if (numValue < numPrev) {
      pillClass = "pill-down";
    } else {
      pillClass = "pill-neutral";
    }

    return (
      <span className={`gei-value-pill ${pillClass}`}>
        {formatByRowRule(rule, numValue)}
      </span>
    );
  };

  // Igual que renderPill, pero para los % de métodos de disposición (el
  // texto ya viene formateado con 2 decimales, sin pasar por formatByRowRule).
  const renderPercentPill = (percent, prevPercent) => {
    if (percent == null || isNaN(percent) || percent === 0) {
      return <span className="gei-value-pill pill-empty" />;
    }

    let pillClass;
    if (prevPercent == null || isNaN(prevPercent) || prevPercent === 0) {
      pillClass = "pill-neutral";
    } else if (percent > prevPercent) {
      pillClass = "pill-up";
    } else if (percent < prevPercent) {
      pillClass = "pill-down";
    } else {
      pillClass = "pill-neutral";
    }

    return (
      <span className={`gei-value-pill ${pillClass}`}>
        {percent.toFixed(2)}
      </span>
    );
  };

  const getRibbonLabel = (item) => {
    if (/^KPIrnp\d+$/.test(item)) {
      const num = parseInt(item.replace("KPIrnp", ""), 10);
      if (num >= 1 && num <= 15) return "Residuos No Peligrosos";
      if (num >= 16 && num <= 21) return "Métodos Disposición - No Peligrosos";
    }

    if (/^KPIrep\d+$/.test(item)) {
      const num = parseInt(item.replace("KPIrep", ""), 10);
      if (num >= 1 && num <= 18) return "Residuos Peligrosos";
      if (num >= 19 && num <= 23) return "Métodos Disposición - Peligrosos";
    }

    return "Otros";
  };

  // Antes acá se excluían los KPIs de métodos de disposición; ahora se
  // muestran como filas propias (con su % sobre el total del grupo), así
  // que no hace falta filtrarlos.
  const conceptosFiltrados = conceptos;

  // 🔸 Filtrar conceptos que tienen todos los años en cero
  const conceptosConDatos = conceptosFiltrados.filter((item) => {
    // Si no hay datos para este concepto, no mostrarlo
    if (!totales[item]) return false;

    // Verificar si hay al menos un año con valor > 0
    const hasNonZeroValue = years.some((year) => {
      const value = totales[item][year]?.total || 0;
      return value > 0;
    });

    return hasNonZeroValue;
  });

  // 🔹 Agrupar los conceptos filtrados (sin ceros), incluyendo los de
  // métodos de disposición — su código vive en disposalMethodCode, no en
  // wasteKPIsCodes.
  const grupos = conceptosConDatos.reduce((acc, item) => {
    let grupo = "Otros";

    const code = wasteKPIsCodes[item] || disposalMethodCode[item];
    if (code) {
      grupo = getRibbonLabel(code);
    }

    if (!acc[grupo]) acc[grupo] = [];
    acc[grupo].push(item);

    return acc;
  }, {});

  // Total del grupo por año (solo para grupos de métodos de disposición),
  // en una unidad común (kg), para poder calcular el % que representa cada
  // método sobre el 100% del grupo.
  const normalizeToKg = (value, unit) => {
    if (!value || isNaN(value)) return 0;
    switch (unit) {
      case "t":
      case "ton": return value * 1000;
      case "g": return value / 1000;
      case "kg":
      default: return value;
    }
  };

  const disposalGroupYearTotals = Object.entries(grupos).reduce((acc, [grupo, items]) => {
    if (!grupo.includes("Métodos Disposición")) return acc;
    acc[grupo] = {};
    years.forEach((yr) => {
      acc[grupo][yr] = items.reduce((sum, item) => {
        const entry = totales[item]?.[yr];
        return sum + normalizeToKg(entry?.total || 0, entry?.unit);
      }, 0);
    });
    return acc;
  }, {});

  // Estado: método seleccionado por indicador (dropdown)
  const [selectedMethod, setSelectedMethod] = useState({});

  // Cambiar método seleccionado en el dropdown
  const handleMethodChange = (item, method) => {
    setSelectedMethod((prev) => ({
      ...prev,
      [item]: method,
    }));
  };

  const KPI_KEY_MAP = {
    fabric_or_scraps_kpis: "fabric_scraps",
    metal_kpis: "metal_clean",
    leftover_food_kpis: "food_waste",
  };

  // KPIs que se dividen por empleado (no por unidad de producción)
  const KPI_PER_EMPLOYEE = [
    "leftover_food_kpis", // Restos de comida / empleados
    "general_trash_kpis", // Basura General / empleados
  ];

  // KPIs que son totales y NO llevan sufijo
  const KPI_NO_SUFFIX = [
    "total_non_hazardous_waste_kpis", // Total Residuos no Peligrosos
    "total_hazardous_waste_kpis", // Total Residuos Peligrosos
  ];

  // Función para obtener el sufijo de unidad según el KPI
  const getUnitSuffix = (item) => {
    // Totales no llevan sufijo
    if (KPI_NO_SUFFIX.includes(item)) {
      return "";
    }
    // KPIs por empleado
    if (KPI_PER_EMPLOYEE.includes(item)) {
      return " / trabajador";
    }
    // Los demás KPIs son por unidad de producción
    return ` / ${t("unit")}`;
  };
  const getItemKey = (item) => {
    // 1. Si está en el mapa especial, usarlo
    if (KPI_KEY_MAP[item]) {
      return KPI_KEY_MAP[item];
    }

    // 2. Fallback estándar: quitar _kpis
    return item.replace(/_kpis$/, "");
  };

  return (
    <div className="kpi-table-section">
    <div className="section-content">
    <Table celled structured size="small" className="gei-kpi-table" unstackable>
      <Table.Header>
        <Table.Row
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: "pointer" }}
        >
          <Table.HeaderCell textAlign="center">{t("code")}</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" style={{ width: "350px" }}>
            {t("indicators")}
          </Table.HeaderCell>
          <Table.HeaderCell
            textAlign="center"
            style={{ width: "180px", whiteSpace: "nowrap" }}
          >
            {t("disposalMethod")}
          </Table.HeaderCell>

          {years.map((year, index) => (
            <Table.HeaderCell textAlign="center" key={index}>
              {year}
            </Table.HeaderCell>
          ))}

          <Table.HeaderCell textAlign="center">{t("LB")}</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" style={{ width: "100px" }}>
            <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {t("units")}
              <Icon name={isOpen ? "chevron up" : "chevron down"} style={{ marginLeft: "auto" }} />
            </span>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      {isOpen && <Table.Body>
        {Object.entries(grupos).map(([grupo, items]) => (
          <React.Fragment key={grupo}>
            {/* 🔹 Encabezado de grupo */}
            <Table.Row className="waste-section-header">
              <Table.Cell colSpan={years.length + 5}>
                {t(grupo)}
              </Table.Cell>
            </Table.Row>

            {items.map((item, index) => {
              const itemKey = getItemKey(item);
              const detailData = detailPerConcept?.[itemKey] || {};
              const methodSelected = selectedMethod[item] || "total";
              const admin = isAdmin(role) || isMaster(role);

              // Opciones del dropdown: Total + métodos disponibles
              const methodOptions = [
                { key: "total", text: t("total"), value: "total" },
                ...Object.keys(detailData)
                  .filter((m) => {
                    // Solo mostrar métodos que tengan datos en algún año
                    return years.some((year) => {
                      const v = detailData?.[m]?.[year]?.total || 0;
                      return v > 0;
                    });
                  })
                  .map((m) => ({
                    key: m,
                    text: t(m),
                    value: m,
                  })),
              ];

              const lbOriginalValue =
                totales[item]?.[getIndicators(item)]?.total || 0;
              const lbOriginalUnit =
                totales[item]?.[getIndicators(item)]?.unit ||
                selectedUnits[item] ||
                "";
              const { value: lbDisplayValue } = autoConvertUnits(
                lbOriginalValue,
                lbOriginalUnit,
              );

              const rowMethods = (() => {
                const candidates = methodOptions.length > 1
                  ? methodOptions.filter((m) => m.key !== "total")
                  : [{ key: "total", text: t("total") }];

                return candidates.filter((m) => {
                  if (m.key === "total") {
                    return years.some((yr) => (totales[item]?.[yr]?.total || 0) > 0);
                  }
                  return years.some((yr) => (detailData?.[m.key]?.[yr]?.total || 0) > 0);
                });
              })();

              return rowMethods.map((methodOpt, mIndex) => {
                const methodKey = methodOpt.key;

                const methodRowValues = years
                  .map((y) => {
                    const val = methodKey === "total"
                      ? (totales[item]?.[y]?.total || 0)
                      : (detailData?.[methodKey]?.[y]?.total || 0);
                    const origUnit = totales[item]?.[y]?.unit || selectedUnits[item] || "";
                    const { value: dv } = autoConvertUnits(val, origUnit);
                    return dv;
                  })
                  .filter((v) => typeof v === "number" && !isNaN(v));

                if (mIndex === 0 && typeof lbDisplayValue === "number" && !isNaN(lbDisplayValue))
                  methodRowValues.push(lbDisplayValue);

                const methodRowRule = resolveRowRule(item, methodRowValues);

                return (
                  <Table.Row key={`${index}-${mIndex}`}>
                    <Table.Cell data-label={t("code")}>
                      {mIndex === 0 ? (wasteKPIsCodes[item] || disposalMethodCode[item]) : ""}
                    </Table.Cell>
                    <Table.Cell data-label={t("indicators")}>{mIndex === 0 ? t(item) : ""}</Table.Cell>

                    {/* Método como texto */}
                    <Table.Cell textAlign="center" data-label={t("disposalMethod")}>
                      {methodOpt.text}
                    </Table.Cell>

                    {/* Celdas por año */}
                    {years.map((year, i) => {
                      const originalValue = methodKey === "total"
                        ? (totales[item]?.[year]?.total || 0)
                        : (detailData?.[methodKey]?.[year]?.total || 0);
                      const originalUnit = methodKey === "total"
                        ? (totales[item]?.[year]?.unit || selectedUnits[item] || "")
                        : (detailData?.[methodKey]?.[year]?.unit || selectedUnits[item] || "");

                      const { value: displayValue } = autoConvertUnits(originalValue, originalUnit);

                      const prevOriginalValue = methodKey === "total"
                        ? (totales[item]?.[year - 1]?.total || 0)
                        : (detailData?.[methodKey]?.[year - 1]?.total || 0);
                      const prevOriginalUnit = methodKey === "total"
                        ? (totales[item]?.[year - 1]?.unit || selectedUnits[item] || "")
                        : (detailData?.[methodKey]?.[year - 1]?.unit || selectedUnits[item] || "");
                      const { value: prevDisplayValue } = autoConvertUnits(prevOriginalValue, prevOriginalUnit);

                      const pill = renderPill(methodRowRule, displayValue, prevDisplayValue);

                      // % que representa este método sobre el total del grupo (año actual y anterior)
                      const groupTotal = disposalGroupYearTotals[grupo]?.[year];
                      const methodPercent = grupo.includes("Métodos Disposición") && groupTotal > 0
                        ? (normalizeToKg(originalValue, originalUnit) / groupTotal) * 100
                        : null;

                      const prevGroupTotal = disposalGroupYearTotals[grupo]?.[year - 1];
                      const prevMethodPercent = grupo.includes("Métodos Disposición") && prevGroupTotal > 0
                        ? (normalizeToKg(prevOriginalValue, prevOriginalUnit) / prevGroupTotal) * 100
                        : null;

                      // Filas de métodos de disposición: mostrar el % (sin el
                      // símbolo "%", que ya está en la columna Unidad) sobre
                      // el total del grupo, con el mismo pill de color que el
                      // resto de la tabla, en vez del valor en kg.
                      const cellContent = methodPercent !== null
                        ? renderPercentPill(methodPercent, prevMethodPercent)
                        : pill;

                      return (
                        <Table.Cell key={i} textAlign="center" data-label={year}>
                          {admin ? (
                            <Popup
                              content={`Valor real: ${parseFloat(Number(originalValue).toFixed(6))} ${normalizeUnit(originalUnit)}`}
                              trigger={<span style={{ cursor: "help" }}>{cellContent}</span>}
                              position="top center"
                              inverted
                            />
                          ) : (
                            cellContent
                          )}
                        </Table.Cell>
                      );
                    })}

                    {/* LB — solo primera fila */}
                    <Table.Cell textAlign="center" data-label={t("LB")}>
                      {mIndex === 0 ? (
                        <Popup
                          content={`Valor real: ${lbOriginalValue} ${lbOriginalUnit}`}
                          trigger={
                            <span style={{ cursor: "help" }}>
                              {formatByRowRule(methodRowRule, lbDisplayValue)}
                            </span>
                          }
                          position="top center"
                          size="tiny"
                        />
                      ) : ""}
                    </Table.Cell>

                    {/* Units — todas las filas del concepto */}
                    <Table.Cell data-label={t("units")}>
                      {(() => {
                        // Métodos de disposición: la celda muestra el % sobre el
                        // total del grupo, no el valor en kg — la unidad es "%".
                        if (grupo.includes("Métodos Disposición")) return "%";

                        // Resolver unidad con fallbacks: selectedUnits → año actual → cualquier año → default
                        const resolvedUnit = selectedUnits[item]
                          || totales[item]?.[year]?.unit
                          || (() => {
                               const availYears = Object.keys(totales[item] || {});
                               for (const y of availYears) {
                                 if (totales[item][y]?.unit) return totales[item][y].unit;
                               }
                               return null;
                             })()
                          || determineWasteUnits(item)?.[0]?.value
                          || "kg";

                        const origVal = totales[item]?.[getIndicators(item)]?.total || 0;
                        const { unit: displayUnit } = autoConvertUnits(origVal, resolvedUnit);
                        const suffix = getUnitSuffix(item);
                        const finalUnit = displayUnit || resolvedUnit;

                        if (displayUnit !== resolvedUnit && resolvedUnit) {
                          return (
                            <span style={{ color: "#000", fontWeight: "bold" }}>
                              {normalizeUnit(displayUnit)}{suffix}
                            </span>
                          );
                        }
                        return finalUnit ? normalizeUnit(finalUnit) + suffix : "";
                      })()}
                    </Table.Cell>
                  </Table.Row>
                );
              });
            })}
          </React.Fragment>
        ))}
      </Table.Body>}
    </Table>
    </div>
    </div>
  );
}

export const YearMonthSelector = ({ onChange, availableYears = [] }) => {
  const currentYear = new Date().getFullYear();

  const years = availableYears.length > 0
    ? [...availableYears].sort((a, b) => b - a).map(y => ({ key: y, text: y, value: y }))
    : [
        { key: currentYear, text: currentYear, value: currentYear },
        { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
        { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
        { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
        { key: currentYear - 4, text: currentYear - 4, value: currentYear - 4 },
      ];

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-12

  useEffect(() => {
    if (availableYears && availableYears.length > 0 && !availableYears.includes(selectedYear)) {
      const sorted = [...availableYears].sort((a, b) => b - a);
      const newYear = sorted[0];
      setSelectedYear(newYear);
      onChange({ year: newYear, month: selectedMonth });
    }
  }, [availableYears]);

  const handleYearChange = (e, { value }) => {
    setSelectedYear(value);
    onChange({ year: value, month: selectedMonth });
  };

  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Dropdown
        placeholder="Año"
        selection
        options={years}
        value={selectedYear}
        onChange={handleYearChange}
        className="year-filter-dropdown"
      />
    </div>
  );
};

function WasteComparisonChart({ resultsByYear, t, valueBaseline }) {
  const barPalette = BAR_PALETTE;

  const { years, barData: allBarData } = useMemo(
    () => buildWasteComparisonData(resultsByYear, valueBaseline, t),
    [resultsByYear, valueBaseline, t],
  );

  const [activeYears, setActiveYears] = useState(years);

  const colorMap = useMemo(() => {
    const map = {};
    years.forEach((y, i) => { map[y] = barPalette[i] || "#ccc"; });
    return map;
  }, [years]);

  const barData = useMemo(
    () => allBarData.filter((d) => activeYears.includes(d.year)),
    [allBarData, activeYears],
  );

  const config = {
    data: barData,
    xField: "type",
    yField: "value",
    seriesField: "year",
    isGroup: true,
    autoFit: true,
    colorField: "year",
    scale: { color: { domain: Object.keys(colorMap), range: Object.values(colorMap) } },
    tooltip: {
      items: [
        (item) => ({
          name: item.year,
          value: formatWhole(item.value),
        }),
      ],
    },
    axis: {
      y: { labelFormatter: (v) => formatMagnitudeAdaptive(v) },
    },
    style: {
      maxWidth: 40,
    },
    height: 400,
    legend: false,
  };

  return (
    <>
      <div className="chartWrapper"><Column {...config} /></div>
      <div className="pillsRow">
        {years.map(year => (
          <div
            key={year}
            className="yearPill"
            onClick={() => setActiveYears(prev =>
              prev.includes(year) ? prev.filter(y => y !== year) : [...prev, year]
            )}
            style={{
              backgroundColor: activeYears.includes(year) ? colorMap[year] : "#E5E7EB",
              color: activeYears.includes(year) ? "white" : "#9CA3AF",
              border: `1px solid ${activeYears.includes(year) ? colorMap[year] : "#D1D5DB"}`,
              opacity: activeYears.includes(year) ? 1 : 0.7,
              textDecoration: activeYears.includes(year) ? "none" : "line-through",
              cursor: "pointer",
              transition: "all 0.2s ease",
              userSelect: "none",
            }}
          >
            {year}
          </div>
        ))}
      </div>
    </>
  );
}

// Las etiquetas del eje X de "Residuos Peligrosos" son más largas que las
// de "Residuos no peligrosos" ("Envases vacíos Químicos (peligrosos)",
// etc.) y G2 las rotaba en vertical al no entrar horizontales — se parten
// en 2 líneas por el espacio más cercano a la mitad en vez de rotar, para
// que se vea igual que el gráfico de arriba.
const wrapAxisLabel = (text, maxCharsPerLine = 14) => {
  const str = String(text);
  if (str.length <= maxCharsPerLine) return str;
  const mid = Math.floor(str.length / 2);
  let splitAt = -1;
  for (let offset = 0; offset < mid; offset++) {
    if (str[mid - offset] === " ") { splitAt = mid - offset; break; }
    if (str[mid + offset] === " ") { splitAt = mid + offset; break; }
  }
  if (splitAt === -1) return str;
  return `${str.slice(0, splitAt)}\n${str.slice(splitAt + 1)}`;
};

function WasteComparisonChartPeligrosos({ resultsByYear, t, valueBaseline }) {
  const barPalette = BAR_PALETTE;

  const { years, barData: allBarData } = useMemo(
    () => buildWasteComparisonDataPeligrosos(resultsByYear, valueBaseline, t),
    [resultsByYear, valueBaseline, t],
  );

  const [activeYears, setActiveYears] = useState(years);

  const colorMap = useMemo(() => {
    const map = {};
    years.forEach((y, i) => { map[y] = barPalette[i] || "#ccc"; });
    return map;
  }, [years]);

  const barData = useMemo(
    () => allBarData.filter((d) => activeYears.includes(d.year)),
    [allBarData, activeYears],
  );

  const config = {
    data: barData,
    xField: "type",
    yField: "value",
    // `group: true` (API v2 de @ant-design/plots) en vez de
    // `seriesField`/`isGroup` (API vieja, v1) — mezclar la vieja con
    // `colorField`/`scale`/`axis` (v2) hacía que el `axis.x` de más abajo
    // se ignorara silenciosamente (mismo tipo de bug ya visto en
    // GEI/Social con `xAxis`/`yAxis` en vez de `axis`).
    group: true,
    autoFit: true,
    colorField: "year",
    scale: { color: { domain: Object.keys(colorMap), range: Object.values(colorMap) } },
    tooltip: {
      items: [
        (item) => ({
          name: item.year,
          value: formatWhole(item.value),
        }),
      ],
    },
    axis: {
      x: { labelAutoRotate: false, labelAutoHide: false, labelFontSize: 10, labelFormatter: (v) => wrapAxisLabel(v) },
      y: { labelFormatter: (v) => formatMagnitudeAdaptive(v) },
    },
    height: 400,
    legend: false,
  };

  return (
    <>
      <div className="chartWrapper"><Column {...config} /></div>
      <div className="pillsRow">
        {years.map(year => (
          <div
            key={year}
            className="yearPill"
            onClick={() => setActiveYears(prev =>
              prev.includes(year) ? prev.filter(y => y !== year) : [...prev, year]
            )}
            style={{
              backgroundColor: activeYears.includes(year) ? colorMap[year] : "#E5E7EB",
              color: activeYears.includes(year) ? "white" : "#9CA3AF",
              border: `1px solid ${activeYears.includes(year) ? colorMap[year] : "#D1D5DB"}`,
              opacity: activeYears.includes(year) ? 1 : 0.7,
              textDecoration: activeYears.includes(year) ? "none" : "line-through",
              cursor: "pointer",
              transition: "all 0.2s ease",
              userSelect: "none",
            }}
          >
            {year}
          </div>
        ))}
      </div>
    </>
  );
}

// Componente para mostrar valores intermedios utilizados en los cálculos
function IntermediateValuesDisplay({ resultsProductions, resultsWorkers, t }) {
  const [isOpen, setIsOpen] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Obtener todos los años disponibles y ordenarlos de mayor a menor
  const availableYears = Object.keys(resultsProductions || {}).sort(
    (a, b) => b - a,
  );

  return (
    <div
      style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #dee2e6",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: "10px 0",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h4 style={{ margin: 0, color: "#495057" }}>
          <Icon name={isOpen ? "chevron down" : "chevron right"} />
          Valores intermedios para verificación de cálculos - Últimos 5 años
        </h4>
        <span style={{ fontSize: "0.9em", color: "#6c757d" }}>
          {isOpen ? "Haz clic para ocultar" : "Haz clic para ver detalles"}
        </span>
      </div>

      {isOpen && (
        <>
          {availableYears.map((year) => (
            <div key={year} style={{ marginBottom: "30px" }}>
              <h5
                style={{
                  marginTop: "20px",
                  marginBottom: "10px",
                  color: "#495057",
                }}
              >
                Año {year}
              </h5>
              <Table celled size="small" style={{ fontSize: "0.9em" }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign="center">Mes</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Producción (VPS/VFS)
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">
                      Trabajadores
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {months.map((month) => {
                    const production = resultsProductions?.[year]?.[month] || 0;
                    const workers = resultsWorkers?.[year]?.[month] || 0;

                    return (
                      <Table.Row key={month}>
                        <Table.Cell textAlign="center">
                          {t ? t(month) : month}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {production > 0 ? production.toFixed(2) : "-"}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {workers > 0 ? workers : "-"}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                  <Table.Row
                    style={{ fontWeight: "bold", backgroundColor: "#e9ecef" }}
                  >
                    <Table.Cell textAlign="center">Total / Promedio</Table.Cell>
                    <Table.Cell textAlign="center">
                      {Object.values(resultsProductions?.[year] || {})
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {(() => {
                        const workersValues = Object.values(
                          resultsWorkers?.[year] || {},
                        );
                        const workersTotal = workersValues.reduce(
                          (a, b) => a + b,
                          0,
                        );
                        const workersMonthsWithData = workersValues.filter(
                          (v) => v > 0,
                        ).length;
                        const avgWorkers =
                          workersMonthsWithData > 0
                            ? (workersTotal / workersMonthsWithData).toFixed(0)
                            : "-";
                        return avgWorkers;
                      })()}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
          ))}

          <div
            style={{
              fontSize: "0.85em",
              color: "#6c757d",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            <strong>Nota:</strong> Estos valores se utilizan como denominadores
            en los cálculos de intensidad de residuos. Producción (VPS/VFS) para
            cálculos de residuos por unidad producida. Trabajadores para
            cálculos de residuos por empleado.
          </div>
        </>
      )}
    </div>
  );
}
